module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Not found","empty":"Not found"},"fi":{"pageTitle":"Sivua ei löytynyt","empty":"Sivua ei löytynyt"}}')
  delete Component.options._Ctor
}
